var getGlobal;

getGlobal = function() {
    if (typeof self !== "undefined") {
        return self;
    }

    if (typeof window !== "undefined") {
        return window;
    }

    if (typeof global !== "undefined") {
        return global;
    }
    throw new Error("unable to locate global object");
};

/**
 * The global object.
 *
 * @public
 */
module.exports = getGlobal();
